
import Vuex from 'vuex'

export const store =  new Vuex.Store({
	state: {
		mainView: 'settings-account',
		mvProp1: '',
		mvProp2: '',
		mvProp3: [],

		detailsList: [],
		detailsComp: 0,

		profileList: [],
		profileComp: 0,

		contactList: [],
		contactComp: 0,

		orgList: [],
		orgComp: 0,
	},

	mutations: {
		setMainView(state, payload) { state.mainView = payload.name; state.leftProp1 = payload.prop1; state.leftProp2 = payload.prop2; state.leftProp3 = payload.prop3 },

		setDetails(state, payload) { state.detailsList = payload.info; state.detailsComp = payload.info1; },
		setDetailsComp(state, payload) { state.detailsComp = payload.info1; },

		setProfile(state, payload) { state.profileList = payload.info; state.profileComp = payload.info1; },
		setProfileComp(state, payload) { state.profileComp = payload.info1; },

		setContacts(state, payload) { state.contactList = payload.info; state.contactComp = payload.info1; },
		setContactsComp(state, payload) { state.contactComp = payload.info1; },

		setOrgs(state, payload) { state.orgList = payload.info; state.orgComp = payload.info1; },
		setOrgsComp(state, payload) { state.orgComp = payload.info1; },
  	},

	actions: {
		getMainView(context, payload) { context.commit("setMainView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2, prop3: payload.prop3 })  },
		
	    getAllUserDetails(context, payload) {
			context.commit("setDetailsComp", { info1: '0' }) 
			axios.get('/utility/user/user/getuserdetails')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setDetails", { info: b, info1: '1' }) 
	          	});
	    },
	    getProfileInformation(context, payload) {
			context.commit("setProfileComp", { info1: '0' }) 
			axios.get('/utility/user/profile/getprofiledetails')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setProfile", { info: b, info1: '1' }) 
	          	});
		},
	    getAllUserContacts(context, payload) {
			context.commit("setContactsComp", { info1: '0' }) 
			axios.get('/utility/user/contact/getallcontactsbyuser')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setContacts", { info: b, info1: '1' }) 
	          	});
	    },
	    getAllUserOrganizations(context, payload) {
			context.commit("setOrgsComp", { info1: '0' }) 
			axios.get('/utility/user/org/getallorgsbyuser')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setOrgs", { info: b, info1: '1' }) 
	          	});
	    },
	}

})